import api from 'Application/api/api';

const getUsers = (signal, configuration, filters = {}, searchQuery) => {
	const { page = 1, itemsPerPage = 20, sortBy = 'firstName', sortDirection = 'ASC' } = configuration;

	const params = {
		...filters,
		query: searchQuery,
	};

	if (page) {
		params.page = page - 1;
	}

	if (itemsPerPage) {
		params.size = itemsPerPage;
	}

	if (sortBy && sortDirection) {
		params.sort = `${sortBy},${sortDirection}`;
	}

	return api.get('/users', {
		params,
		signal,
	});
};

export default getUsers;
